import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	// TODO: Remove when cleaning up smart_fields_gic_toggle_fg
	showFields: {
		id: 'issue-create.modal.create-form.actions-container.dropdown-menu.show-fields',
		defaultMessage: 'Show fields',
		description: 'Label for show fields menu item in issue-create modal header',
	},
	configureFields: {
		id: 'issue-create.modal.create-form.actions-container.dropdown-menu.configure-fields',
		defaultMessage: 'Configure fields',
		description: 'Label for configure fields menu item in issue-create modal header',
	},
	findField: {
		id: 'issue-create.modal.create-form.actions-container.dropdown-menu.find-field',
		defaultMessage: 'Find your field',
		description: 'Label for find field menu item in issue-create modal header',
	},
	moreActions: {
		id: 'issue-create.modal.create-form.actions-container.dropdown-menu.more-actions',
		defaultMessage: 'More actions for this issue',
		description: 'Aria-label for more actions button in issue-create modal',
	},
	moreActionsIssueTermRefresh: {
		id: 'issue-create.modal.create-form.actions-container.dropdown-menu.more-actions-issue-term-refresh',
		defaultMessage: 'More actions for this work item',
		description: 'Aria-label for more actions button in issue-create modal',
	},
	moreActionsIssueTerminologyRefreshM4: {
		id: 'issue-create.modal.create-form.actions-container.dropdown-menu.more-actions-issue-terminology-refresh-m4',
		defaultMessage: 'More actions for this {issueType}',
		description: 'Aria-label for more actions button in issue-create modal',
	},
});
